/**
 * 番組の種類
 */
export const SCHEDULE_TYPE = {
  new: {
    id: 1,
    code: '[**f2e8.img**]',
    character: '新',
    label: '新番組',
    key: 'new',
  },
  last: {
    id: 2,
    code: '[**f2ea.img**]',
    character: '終',
    label: '最終話',
    key: 'last',
  },
  live: {
    id: 3,
    code: '[**f2eb.img**]',
    character: '生',
    label: '生放送',
    key: 'live',
  },
  caption: {
    id: 4,
    code: '[**f2d3.img**]',
    character: '字',
    label: '字幕',
    key: 'caption',
  },
  bilingual: {
    id: 5,
    code: '[**f2d7.img**]',
    character: '二',
    label: '二ヶ国語',
    key: 'bilingual',
  },
} as const;

export type ScheduleTypeCode = typeof SCHEDULE_TYPE[keyof typeof SCHEDULE_TYPE]['code'];
export type ScheduleTypeCharacter = typeof SCHEDULE_TYPE[keyof typeof SCHEDULE_TYPE]['character'];
export type ScheduleTypeLabel = typeof SCHEDULE_TYPE[keyof typeof SCHEDULE_TYPE]['label'];
export type ScheduleTypeKey = typeof SCHEDULE_TYPE[keyof typeof SCHEDULE_TYPE]['key'];

/**
 * 番組の種類一覧
 * NOTE: 並び順を担保
 */
export const SCHEDULE_TYPES = [
  SCHEDULE_TYPE.new,
  SCHEDULE_TYPE.last,
  SCHEDULE_TYPE.live,
  SCHEDULE_TYPE.caption,
  SCHEDULE_TYPE.bilingual,
];

/**
 * 番組の種類を示すコードの一覧
 */
export const SCHEDULE_TYPE_CODES = [
  SCHEDULE_TYPE.new.code,
  SCHEDULE_TYPE.last.code,
  SCHEDULE_TYPE.live.code,
  SCHEDULE_TYPE.caption.code,
  SCHEDULE_TYPE.bilingual.code,
];

/**
 * 番組の種類を示す1字の一覧
 */
export const SCHEDULE_TYPE_CHARACTERS = [
  SCHEDULE_TYPE.new.character,
  SCHEDULE_TYPE.last.character,
  SCHEDULE_TYPE.live.character,
  SCHEDULE_TYPE.caption.character,
  SCHEDULE_TYPE.bilingual.character,
];
